// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const current = "PageSizeSelector__current__hezqU";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const label = "PageSizeSelector__label__nmdWk font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const medium = "500";
export const option = "PageSizeSelector__option__KjR+I";
export const options = "PageSizeSelector__options__4ywyk";
export const pageSizeSelector = "PageSizeSelector__pageSizeSelector__wOPjO";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";